
class ProductSizeSorter {

	/**
	 * Product size and balance data object.
	 * 
	 * @typedef {object} ProductData
	 * @property {string} size - Product size.
	 */

	/**
	 * Sort by size (smaller first).
	 * 
	 * @param {ProductData[]} data - Product data.
	 * @returns {ProductData[]} Sorted product data.
	 */
	sortProductSizes(data) {

		if (!Array.isArray(data)) {
			return data;
		}

		const numericSizes = [];
		const letterSizes = [];
		const mixedSizes = [];

		//Correct order of these sizes. Not alphabetical.
		const sizeTable = ["XXS", "XS", "S", "SM", "S/M", "M", "M/L", "L", "L/XL", "XL", "XL/XXL", "XXL", "2XL", "XXXL", "3XL", "XXXXL", "4XL", "5XL"];

		//Normalize sizes
		for (let itemData of data) {

			if (itemData.sizeSort === undefined) {
				itemData.sizeSort = itemData.size;
			}

			itemData.sizeSort = String(itemData.sizeSort).replace(/\([^)]*\)/g, "").replace(/\+/g, "").trim().toUpperCase().split(",")[0];

			const dashless = itemData.sizeSort.split("-");

			if (dashless.length > 1 && dashless[0] !== "") {
				itemData.sizeSort = String(dashless[0]).trim();
			}

			if (itemData.sizeSort !== "" && itemData.sizeSort !== null && itemData.sizeSort !== undefined) {


				//Check for numeric size (this matches 1, 1,11)
				let isNumeric = String(parseFloat(itemData.sizeSort)) === itemData.sizeSort; //itemData.sizeSort.match(/^\d+(,\d+)?$/g) || itemData.sizeSort.match(/^\d+(\.\d+)?$/g);

				const letters = /[a-zA-ZöäåÖÄÅ]/;
				const numbers = /\d/;
				const hasLetter = itemData.sizeSort.match(letters);
				const hasNumbers = itemData.sizeSort.match(numbers);

				if (hasLetter && hasNumbers && !sizeTable.includes(itemData.sizeSort)) {
					itemData.sizeSort = itemData.sizeSort.replace(/[^\d.-]/g, "");
					isNumeric = true;
				} else if (!hasLetter && !hasNumbers) {
					isNumeric = false;
				}

				//Handle sizes with numbers only (e.g. 38, 40, 42)
				if (isNumeric) {

					const numericSize = Number(itemData.sizeSort);

					//Add only unique sizes to list
					if (!numericSizes.includes(numericSize)) {
						numericSizes.push(itemData);
					}

					//Handle letter sizes (e.g. S, M, L)
				} else if (sizeTable.includes(itemData.sizeSort)) {
					if (!letterSizes.includes(itemData.sizeSort)) {
						letterSizes.push(itemData);
					}

					//Mixed crap (e.g. 90D XLS XLL)
				} else {

					mixedSizes.push(itemData);

				}

			} else {
				//Something very weird crap (like missing size)
				mixedSizes.push(itemData);
			}

		}

		//Sort sizes
		letterSizes.sort((a, b) => {
			const asize = sizeTable.indexOf(a.sizeSort);
			const bsize = sizeTable.indexOf(b.sizeSort);

			if (asize === bsize) {
				return 0;
			}

			return (asize > bsize) ? 1 : -1;
		});

		numericSizes.sort((a, b) => {
			return Number(String(a.sizeSort).replace(",", ".")) - Number(String(b.sizeSort).replace(",", "."));
		});

		mixedSizes.sort((a, b) => {
			return a.sizeSort - b.sizeSort;
		});

		// Merge all three arrays
		// 1. numeric, 2. letter, 3. mixed
		return [...numericSizes, ...letterSizes, ...mixedSizes];
	}
}

export default new ProductSizeSorter();